<template>
  <v-card>
    <v-toolbar card dense color="transparent">
      <v-toolbar-title><h4>Expedientes: Documentos</h4></v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn icon>
        <v-icon>more_vert</v-icon>
      </v-btn> -->
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <template>
        <v-data-table
          :items="documents"
          :pagination.sync="pagination"
          hide-actions
          hide-headers
          class="elevation-0"
        >
          <template slot="items" slot-scope="props">
            <!-- <td>
              <v-avatar size="36px">
                <img :src="props.item.avatar" :alt="props.item.username" />
              </v-avatar>
            </td> -->
            <td>{{ props.item.name }}</td>
            <td class="text-xs-right font-weight-thin title">
              {{ props.item.value }}
            </td>
            <td class="text-xs-left">
              <v-progress-linear
                :value="props.item.progress"
                height="5"
                :color="props.item.color"
              ></v-progress-linear>
            </td>
            <!-- <td class="text-xs-right">
              <v-btn flat icon color="grey">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn flat icon color="grey">
                <v-icon>delete</v-icon>
              </v-btn>
            </td> -->
          </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
      <template v-if="pagination.rowsPerPage > 0">
        <v-btn block flat class="ma-0" @click="pagination.rowsPerPage = -1">
          <v-icon>mdi-chevron-down</v-icon>
          Otros Documentos
        </v-btn>
      </template>
      <template v-else>
        <v-btn block flat class="ma-0" @click="pagination.rowsPerPage = 9">
          <v-icon>mdi-chevron-up</v-icon>
          Otros Documentos
        </v-btn>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ["documents"],
  data() {
    return {
      pagination: {
        sortBy: "name",
        rowsPerPage: 9
      }
    };
  }
};
</script>
